import { csvFormat } from 'd3';

/**
 * @param {any} data - The data to be exported.
 * @param {Function} formatter - A function that transform the data into an array of objects for CSV export.
 * @param {string} filename - The filename for the CSV file.
 */
export default function csvExporter(data, formatter, filename = 'output.csv') {
  const formattedData = formatter(data);
  const csvString = csvFormat(formattedData);
  const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
